import bus from './bus';

function post(url, data, callback) {
    let http = new XMLHttpRequest();
    http.onreadystatechange = function () {
        if (http.readyState === 4) {
            if (http.status === 200) {
                let response = JSON.parse(http.responseText);
                if (response) {
                    if (response.relogin) {
                        alert(response.error);
                        bus.emit('view', 'qrcode');
                    } else {
                        if (!response.result) {
                            bus.emit('showTips', response.error);
                        }
                        callback(response);
                    }
                } else {
                    alert('服务器返回错误内容');
                }
            } else {
                if (http.status) {
                    bus.emit('showTips', http.status + ' ' + http.statusText);
                    callback({result: false, error: http.status + ' ' + http.statusText});
                } else {
                    bus.emit('showTips', '提交失败：无法连接服务器');
                    callback({result: false, error: '提交失败：无法连接服务器'});
                }
            }
        }
    };
    http.open('POST', url, true);
    http.setRequestHeader('Content-Type', 'application/json');
    http.send(JSON.stringify(data));
}

let Ajax = {
    post: post
};

export default Ajax;



// WEBPACK FOOTER //
// ./src/ajax.js